

import $ from "jquery";
import appHelper from "../lib/appHelper"
import { webp } from "aiyuke-front-lib";


export default class articleHelper {


    data = {}

    constructor(data){
        this.data = data;
    }

    /**
     *
     * @param {event} nativeEvent
     * @param {jQuery.selector} wrapOfJQSelector
     * @param {Object} shareData
     * @param {callback} otherClick
     */
    static contentClick ( nativeEvent , wrapOfJQSelector  , shareData , otherClick ) {

        var target = nativeEvent.target,
            $img = $(target),
            allImg,
            index = 0,
            showImg = 1;
        let domImgContent = $(wrapOfJQSelector);

        if ($img.is("img")) {
            allImg = domImgContent.find("img");
            index = allImg.index($img);
            // 如果存在id 说明是gif图
            if ($img[0].id) {
                // gif 不自动播放代码取消
            }
            if (showImg && !$($img[0]).hasClass("video-img")) {
                // 打开原生图集
                try{
                    let jsonString  = JSON.stringify(
                        $.map(allImg, function(img) {
                            var src= $(img).attr('data-src');
                            if (src == null || src == undefined ){
                                src= $(img).attr('src');
                            }

                            src = src
                                    .replace("https", "http")
                                    .replace('aykimghttp://' , 'http://')
                                    .replace('aykimghttps://' , 'https://');
                            var reg = /(.*?)\.((jpg)|(jpeg))/gi,
                                jpgReg = /.((jpg)|(jpeg))/gi,
                                isJpgReg = /.jpg/,
                                arr = src.match(reg),
                                bigSrc = "";
                            if (jpgReg.test(src)) {
                                if (arr[1]) {
                                    if (isJpgReg.test(src)) {
                                        bigSrc = arr[0];
                                    } else {
                                        bigSrc = arr[0];
                                    }
                                } else {
                                    bigSrc = arr[0];
                                }
                            } else {
                                bigSrc = src;
                            }
                            return {
                                url: webp.replaceSrcToNative(
                                    bigSrc
                                ),
                                title: shareData.title,
                                des: shareData.desc
                            };
                        })
                    );

                    appHelper.checkTYSNAV(function() {
                        appHelper.pipe(
                            "showImgGroup",
                            [
                                allImg.length.toString(),
                                index.toString(),
                                jsonString
                            ]
                        );
                    });


                } catch (e){
                    alert(e.message);
                }

            }
        } else if ($img.is("span")) {
            // 点击到动图标签也加载动图
            var $gifImg = $(target).next("img");
            if ($gifImg[0].id) {
                var gifReg = /.gif/;
                var id = $gifImg[0].id;
                var imgSrc =
                    $("#" + id).attr("src") || $("#" + id).data("original");
                var gifSrc = imgSrc.substring(0, imgSrc.length - 3) + "gif";
                $("#" + id).attr("src", gifSrc);
                $("#" + id).data("original", gifSrc);
                $(target).html("加载中...");
                $("#" + id).load(function() {
                    $(target).css("visibility", "hidden");
                });
            }
        } else {
            if (otherClick != undefined){
                otherClick();
            }
        }
    }

    static bodyScrollBottom( callback , scrollTopCallback ){

        $(document).ready(function () {
            window.addEventListener("scroll",function(e){
                if (scrollTopCallback != undefined ){
                    scrollTopCallback($(document).scrollTop());
                }
                if (($(document).scrollTop()) >= ($(document).height() - $(window).height())) {
                    //当底部基本距离+滚动的高度〉=文档的高度-窗体的高度时；
                    //我们需要去异步加载数据了
                    callback();
                }
            });
        });

    }

    static fixRichText( content ){
        content = content.replace(/&lt;/g , '<')
            .replace(/&gt;/g , '>')
            .replace(/data-original=/g,'data-src=');
        content = content.replace("/class=/g" , "old-class=");  //图片不能带class属性
        content = content.replace(/data\-src/g , "class='preimg' data-src");
        //可以屏蔽下面这行
        content = content.replace(/upload\/upload/g , 'upload');    //这个是后端的问题
        //webp
        content = this.replaceWebp(content);
        return content;
    }

    /**
     * 回复详情不进行懒加载
     *  - //todo 懒加载 引起重新加载图片，导致vue渲染出问题，后续解决后再改
     * @param content
     * @return {*}
     */
    static fixReplyContent( content ){
        content = content.replace(/&lt;/g , '<')
            .replace(/&gt;/g , '>')
            .replace(/data-original=/g,'src=');

        //可以屏蔽下面这行
        content = content.replace(/upload\/upload/g , 'upload');    //这个是后端的问题

        //webp
        content = this.replaceWebp(content);
        return content;
    }


    /**
     *
     * @param {Array} replyListArray
     * @param {int} currentPage
     * @param {int} totalRecords
     * @param {String} orderType Only can be 'asc' or 'desc'
     * @return {*}
     */
    static fixReplyItem( replyListArray , currentPage , totalRecords , orderType  ){

        let ret = [] , mThis = this;
        if (!Array.isArray(replyListArray)){
            return replyListArray;
        }

        console.log("total:" , totalRecords , orderType);

        replyListArray.forEach(function(value , key ){
            //计算楼层
            if (orderType == 'asc'){
                value.floor = (currentPage - 1 ) * 10 + 1 + key;
            } else {
                //降序
                value.floor = totalRecords - ( (currentPage - 1 ) * 10  + key );
                console.log(value.floor);
            }
            value.verifyClass = '';
            //value.isVip = true;
            if (value.zmtType > 0){
                value.verifyClass += " ver" + value.zmtType;
            }
            if (value.isVip == '1'){
                value.verifyClass += 'vip';
            }
            value.userimg = mThis.replaceWebp(value.user_image);
            value.content = value.message;
            value.username = value.contactname;
            value.time = value.date;
            value.address = value.city;

            if (value.position.state == 1){
                value.isPraise = 0;
            } else if (value.position.state == 2){
                value.isPraise = 1 ;
            }
            value.praise_num = value.position.count;

            ret[key] = value;
        });
        console.log(ret);
        return ret;
    }


    static isSupWebp(){
        let iosSupVersion = 55;    //ver 5.5
        let appVersion = appHelper.checkApp();

        if (appVersion.app && appVersion.ios && appVersion.version >= iosSupVersion){
            console.log('current ayk ios app ' , appVersion.version);
            return true;
        }
        try{
            return document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') == 0;
        } catch(e){
            return false;
        }
    }


    /**
     * @param rawHTML
     */
    static replaceWebp(rawHTML){
        if (!this.isSupWebp()){
            return rawHTML;
        }
        //头像
        let appVersion = appHelper.checkApp();
        //ios 需修改 协议
        // 比如 aykimghttp://xxx.com
        let scheme = (appVersion.ios
            && appVersion.version >= 55
        ) ? "aykimg" : '';

        rawHTML = rawHTML.replace(/(http|https):\/\/([a-zA-Z_\-]+)\.tiyushe\.com\/(upload)?([a-zA-Z0-9_\.\/\?]+)\.(jpg|png|jpeg)/g
            , scheme + '$1://$2.tiyushe.com/$3$4.$5.webp');
        return rawHTML;
    }

    static openPersonalPage(uid){
        appHelper.checkTYSNAV(function() {
            appHelper.pipe(
                "openPersonalPage",
                [uid]
            );
        });
    }

    static debug(callback){
        try{
            callback();
        }catch (e){
            alert(e.message);
        }
    }

}



// WEBPACK FOOTER //
// ./src/lib/articleHelper.js